// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__DYDrz","ih4":"Banner_ih4__5ltKt","ih41":"Banner_ih41__O+rpp"};